var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9962 1.76472C11.9759 1.54868 11.876 1.35376 11.7145 1.21569L10.5088 0.184218C10.1763 -0.100045 9.68389 -0.0496891 9.41075 0.296299L4.3405 6.71819L2.30366 4.90135C1.97667 4.6114 1.48346 4.64958 1.20329 4.98988L0.187997 6.22358C0.0522071 6.38764 -0.013347 6.59799 0.00226094 6.81403C0.0178689 7.03007 0.114639 7.22743 0.272279 7.36875L4.12433 10.8043C4.26714 10.9318 4.44507 11 4.63081 11C4.65422 11 4.67685 10.9992 4.70026 10.9968C4.91097 10.9773 5.10061 10.8733 5.23484 10.7036L11.823 2.35923C11.9548 2.19192 12.0165 1.97994 11.9962 1.76472Z",
    fill: "#46C783"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.7a69a1c45860c21e57513cdbaece60de.svg";
export { ForwardRef as ReactComponent };